import React, { useState, useEffect } from 'react';
import axios from 'axios';

import {Configs} from '../api';
const AddInput =()=> {
    

const [name, setname] = useState('')

const adddata = async (e)=>{
  e.preventDefault();
  try {
  const result = await axios.post(Configs.banners,{name : name})
 
  console.log(result);
  window.location.reload();
}
  catch (error) {
    console.log(error.message);
}
}
useEffect(() => {
  const dataID = async() =>{

    try {
    const result = await axios.get(Configs.banners)
      setname(result.data.banners[0].name)
  //  console.log(result.data.banners[0].name)
  }
    catch (error) {
      console.log(error.message);
  }
  }
  dataID();
}, [])

           return ( 

<div className="container-fluid" >
    <h1 className="text-center mt-5">Banners</h1>
      <form className="d-flex mt-5 mb-3 algnItm" onSubmit={adddata}>
          <input type='text' 
          className="form-control input-styl1"
          value={name}
          onChange={e=> setname(e.target.value)}
          placeholder="Add Text Here"

        >
           </input>
          <button className="btn btn-success">add</button>


      </form>
    </div>
         );
    }

 
export default AddInput;
